<splash-screen></splash-screen>

<mat-drawer-container class="indu-sidenav" autosize>
  <!-- Mobile navigation (< 1024px): same groups and sub-sections as the top bar, same permission filter.
       Kept outside @if so it is projected into the container's drawer slot. -->
    <mat-drawer
      #navDrawer
      id="tp-nav-drawer"
      class="tp-nav-drawer"
      mode="over"
      position="start"
      autoFocus="first-tabbable"
      [opened]="navDrawerOpen"
      (closedStart)="navDrawerOpen = false"
      aria-label="Menú principal"
    >
      <div class="tp-nav-drawer__head">
        <span class="tp-logo">
          <img src="assets/logos/TuPiscinero-logo-small.png" alt="" />
        </span>
        <span class="tp-nav-drawer__brand">Tu Piscinero</span>
        <button
          mat-icon-button
          type="button"
          class="tp-nav-drawer__close"
          aria-label="Cerrar menú"
          (click)="navDrawerOpen = false"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <nav aria-label="Secciones">
        <ul class="tp-nav-drawer__list">
          @for (section of drawerSections; track section.group) {
            <li>
              <button
                type="button"
                class="tp-nav-drawer__group"
                [class.tp-nav-drawer__group--current]="selectedGroup === section.group"
                [attr.aria-expanded]="section.items.length ? expandedDrawerGroup === section.group : null"
                [attr.aria-controls]="section.items.length ? 'tp-nav-sub-' + section.group : null"
                (click)="toggleDrawerGroup(section)"
              >
                <span
                  class="tp-nav-icon"
                  aria-hidden="true"
                  [style.--tp-nav-icon]="'url(assets/icons/menu/' + section.icon + ')'"
                ></span>
                <span class="tp-nav-drawer__group-label">{{ section.label }}</span>
                @if (section.items.length) {
                  <mat-icon class="tp-nav-drawer__chevron" aria-hidden="true">
                    {{ expandedDrawerGroup === section.group ? 'expand_less' : 'expand_more' }}
                  </mat-icon>
                }
              </button>
              @if (section.items.length && expandedDrawerGroup === section.group) {
                <ul class="tp-nav-drawer__sub" [id]="'tp-nav-sub-' + section.group">
                  @for (item of section.items; track item.path) {
                    <li>
                      <a
                        class="tp-nav-drawer__link"
                        [routerLink]="['/' + item.path]"
                        routerLinkActive="tp-nav-drawer__link--active"
                        ariaCurrentWhenActive="page"
                        (click)="navDrawerOpen = false"
                        >{{ item.data?.['menu']?.description }}</a
                      >
                    </li>
                  }
                </ul>
              }
            </li>
          }
        </ul>
      </nav>
    </mat-drawer>

  @if (showHeader) {
    <header class="tp-shell-header">
      <div class="tp-topbar">
        @if (isCompactNav) {
          <button
            mat-icon-button
            type="button"
            class="tp-topbar__menu-btn"
            aria-label="Abrir menú"
            aria-controls="tp-nav-drawer"
            [attr.aria-expanded]="navDrawerOpen"
            (click)="openNavDrawer()"
          >
            <mat-icon>menu</mat-icon>
          </button>
        }

        <span class="tp-logo tp-topbar__logo" title="Tu Piscinero">
          <img src="assets/logos/TuPiscinero-logo-small.png" alt="Tu Piscinero" />
        </span>

        @if (!isCompactNav) {
          <nav class="tp-topbar__nav" aria-label="Menú principal">
            @for (item of navGroups; track item.group) {
              @if (checkHasAnyPermission(item.group)) {
                <button
                  type="button"
                  class="tp-topbar__item"
                  [ngClass]="checkSelectedGroup(item.group)"
                  [attr.aria-current]="selectedGroup === item.group ? 'page' : null"
                  (click)="filterMenuOptions(item.group)"
                >
                  <span
                    class="tp-nav-icon"
                    aria-hidden="true"
                    [style.--tp-nav-icon]="'url(assets/icons/menu/' + item.icon + ')'"
                  ></span>
                  <span class="tp-topbar__label">{{ item.label }}</span>
                </button>
              }
            }
          </nav>
        } @else {
          <span class="tp-topbar__spacer"></span>
        }

        @if (userSvc.isLoggedIn) {
          <div class="tp-topbar__user">
            <app-notifications
              [otherSidebarIsOpen]="toggledSidebar"
              (openNotifiDrawerEvent)="closeDrawer()"
              (launchNotificationCenterEvent)="filterMenuOptions('notifications')"
            ></app-notifications>
            <app-user-menu></app-user-menu>
          </div>
        }
      </div>

      <div class="tp-subbar">
        @if (sharedService.selectedFranchise | async; as franchise) {
          <div class="tp-franchise-chip">
            @if (userSvc.user) {
              <span class="tp-franchise-chip__avatar" [style.background-image]="'url(' + userSvc.user.picture + ')'"></span>
            }
            <span class="tp-franchise-chip__text">
              <span class="tp-franchise-chip__caption">Franquicia</span>
              <span class="tp-franchise-chip__name">{{ getDisplayName(franchise.name) }}</span>
            </span>
            <button
              type="button"
              class="tp-franchise-chip__close"
              aria-label="Quitar franquicia seleccionada"
              (click)="closeFranchise()"
            >
              <mat-icon aria-hidden="true">close</mat-icon>
            </button>
          </div>
        }

        <nav class="tp-subbar__tabs" aria-label="Subsecciones" #subbarTabs>
          @for (option of secondaryMenu; track option.path) {
            @if (option.data.menu && option.data.menu.description) {
              <!-- A detail page (data.menu.pathParent) highlights the tab of its parent list. -->
              <a
                class="tp-subbar__tab"
                [attr.data-path]="option.path"
                [routerLink]="['/' + option.path]"
                routerLinkActive
                #tabLink="routerLinkActive"
                [routerLinkActiveOptions]="{ exact: false }"
                [class.tp-subbar__tab--active]="tabLink.isActive || option.path === parentTabPath"
                [attr.aria-current]="tabLink.isActive ? 'page' : option.path === parentTabPath ? 'true' : null"
                >{{ option.data.menu.description }}</a
              >
            }
          }
        </nav>

        @if (displayOpenFilterButton) {
          <div class="tp-subbar__tools">
            <button type="button" class="tp-subbar__tool" title="Abrir filtros" aria-label="Abrir filtros" (click)="toggleVisibility()">
              <img src="assets/icons/filter/open-filter.svg" alt="" />
            </button>
            <button type="button" class="tp-subbar__tool" title="Abrir etiquetas" aria-label="Abrir etiquetas" (click)="toggleTagVisibility()">
              <img src="assets/icons/common/tag.png" alt="" />
            </button>
          </div>
        }
      </div>
    </header>
  }
  <div
    class="indu-sidenav-content scrollable-content w-100 text-center m-0"
    [ngClass]="{ 'main-container': showHeader }"
    >
    @if (showHeader) {
      <app-back-bar></app-back-bar>
    }
    <div class="row">
      <router-outlet (activate)="modifyHeader()"></router-outlet>
    </div>
  </div>
</mat-drawer-container>
